import { FormDuufGroup, FormDuufSubmit } from '@ubo/form-duuf'
import { useLosseData } from '@ubo/losse-sjedel'
import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'
import Form from '~/components/elements/Form'
import Loading from '~/components/elements/Loading'
import type { Component_Popupglobaal } from '~/graphql/types'

export default function PopupGlobaal() {
  const [open, setOpen] = useState(false)
  const [response] = useLosseData<{ data: Component_Popupglobaal }>('PopupGlobaal', { id: 1405 })

  if (!response) return null

  return (
    <section
      className="fixed sm:top-[140px] 2xl:top-0 bottom-4 sm:bottom-0 my-auto h-fit max-sm:left-4 sm:right-0 max-sm:z-[9999999999] z-40 flex"
      data-component="PopupGlobaal"
      id="form-newsletter"
    >
      <div
        onClick={() => setOpen(!open)}
        className="bg-ftf-punch z-20 h-fit flex max-sm:justify-center max-sm:items-center sm:px-4 sm:py-5 max-sm:rounded-[40px] max-sm:w-14 max-sm:h-14 sm:rounded-l-[15px] gap-2 flex-col hover:cursor-pointer"
      >
        <div className="text-white sm:block hidden font-bold vertical-rl">
          <p className="rotate-180 transform text-left text-base font-bold">Nieuwsbrief</p>
        </div>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-white">
          <g id="fi-sr-envelope" clipPath="url(#clip0_537_121)">
            <path
              id="Vector"
              d="M23.954 5.54187L15.536 13.9599C14.5974 14.8961 13.3257 15.4219 12 15.4219C10.6743 15.4219 9.40263 14.8961 8.464 13.9599L0.046 5.54187C0.032 5.69987 0 5.84287 0 5.99987V17.9999C0.00158786 19.3255 0.528882 20.5963 1.46622 21.5337C2.40356 22.471 3.67441 22.9983 5 22.9999H19C20.3256 22.9983 21.5964 22.471 22.5338 21.5337C23.4711 20.5963 23.9984 19.3255 24 17.9999V5.99987C24 5.84287 23.968 5.69987 23.954 5.54187Z"
              fill="currentColor"
            />
            <path
              id="Vector_2"
              d="M14.122 12.5459L23.256 3.41088C22.8135 2.6772 22.1895 2.06992 21.444 1.64761C20.6985 1.2253 19.8568 1.00222 19 0.999878H5.00002C4.14324 1.00222 3.30152 1.2253 2.55605 1.64761C1.81057 2.06992 1.1865 2.6772 0.744019 3.41088L9.87802 12.5459C10.4416 13.1072 11.2046 13.4223 12 13.4223C12.7954 13.4223 13.5584 13.1072 14.122 12.5459Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_537_121">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            animate={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            className="bg-black/30 fixed flex sm:hidden justify-center items-center h-full w-full left-0 top-0"
            onClick={() => setOpen(false)}
          >
            <div onClick={(e) => e.stopPropagation()} className="bg-site-base rounded-[15px] relative">
              <svg
                onClick={() => setOpen(false)}
                className="absolute z-10 right-3 top-3"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
              >
                <path
                  fill="white"
                  d="m8.4 16.308l3.6-3.6l3.6 3.6l.708-.708l-3.6-3.6l3.6-3.6l-.708-.708l-3.6 3.6l-3.6-3.6l-.708.708l3.6 3.6l-3.6 3.6zM12.003 21q-1.866 0-3.51-.708q-1.643-.709-2.859-1.924q-1.216-1.214-1.925-2.856Q3 13.87 3 12.003q0-1.866.708-3.51q.709-1.643 1.924-2.859q1.214-1.216 2.856-1.925Q10.13 3 11.997 3q1.866 0 3.51.708q1.643.709 2.859 1.924q1.216 1.214 1.925 2.856Q21 10.13 21 11.997q0 1.866-.708 3.51q-.709 1.643-1.924 2.859q-1.214 1.216-2.856 1.925Q13.87 21 12.003 21"
                />
              </svg>
              <NewsLetterForm data={response.data} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <motion.div
        initial={{
          width: 0
        }}
        animate={open ? { width: 280 } : { width: 0 }}
        className="bg-ftf-punch sm:block hidden overflow-hidden relative rounded-bl-[15px]"
      >
        <NewsLetterForm data={response.data} />
      </motion.div>
    </section>
  )
}

function NewsLetterForm({ data }: { data: Component_Popupglobaal }) {
  return (
    <div className="form w-[280px]">
      <Form generate={false} data={data.form} customBg renderLoading={() => <Loading />}>
        <>
          <h3 className="text-white mb-2 font-site-heading">{data.description}</h3>
          <FormDuufGroup hideIds={[]} />
          <FormDuufSubmit />
        </>
      </Form>
    </div>
  )
}
